export default "__VITE_ASSET__BGU5wPfE__"